import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';
import { createRESTContract } from '../../index';
import { DataSourceDetailsSchema } from '../data-sources/data-sources.schema';
import { SyncBodySchema } from '../data-sources/sync.schema';
import {
  TopdeskSettingsResponseSchema,
  TopdeskSettingsSchema,
} from './topdesk.schema';

export const topdeskContract = createRESTContract({
  syncKnowledgeArticles: {
    method: 'POST',
    path: '/topdesk/knowledge-articles/sync',
    permissions: [],
    body: SyncBodySchema,
    response: DataSourceDetailsSchema,
  },
  getSettings: {
    method: 'GET',
    path: '/topdesk/settings',
    permissions: [PERMISSIONS.COMPANY.COMPANY_GENERAL_SETTINGS_READ],
    response: TopdeskSettingsResponseSchema,
  },
  updateSettings: {
    method: 'PATCH',
    path: '/topdesk/settings',
    permissions: [PERMISSIONS.COMPANY.COMPANY_GENERAL_SETTINGS_EDIT],
    body: TopdeskSettingsSchema,
    response: z.void(),
  },
});
